import type { LoggerCollector } from './LoggerCollector'
import { Syslog } from './syslog/Syslog'
import { toVtexLog } from './utils/toVtexLog'
import { requestJson } from '../utils/http/request'
import { isRecord } from '../utils/type/isRecord'

export type OpenSearchGatewayCollectorArgs = {
  searchIndex: string
  endpoint: string
  token: string
}

export const isOpenSearchGatewayCollectorArgs = (
  value: unknown
): value is OpenSearchGatewayCollectorArgs => {
  return (
    isRecord(value) &&
    typeof value.searchIndex === 'string' &&
    typeof value.endpoint === 'string' &&
    typeof value.token === 'string'
  )
}

// TODO: implement automated tests for it
export const OpenSearchGatewayCollector = {
  create({ searchIndex, endpoint, token }: OpenSearchGatewayCollectorArgs) {
    const syslog = Syslog.create()

    const collector: LoggerCollector = {
      async send(events, { signal }) {
        const logs = events
          .map((event) => syslog.format(toVtexLog({ searchIndex, ...event })))
          .join('\n')

        await requestJson(endpoint, {
          signal,
          method: 'POST',
          body: logs,
          headers: {
            ApiKey: token,
            'Content-Type': 'text/plain',
          },
          credentials: 'omit',
        })
      },
    }

    return collector
  },
}
